import { useQuery } from '@apollo/client/react'
import { GET_CONTENT_STATS } from '@/lib/operations/dashboard'
import type { ContentStats } from '@/lib/types'

export function useDashboardStats(
  clientId: string | null,
  filters?: { startDate?: string; endDate?: string }
) {
  const { data, loading, error } = useQuery<{ contentStats: ContentStats }>(GET_CONTENT_STATS, {
    variables: {
      clientId,
      startDate: filters?.startDate,
      endDate: filters?.endDate,
    },
    skip: !clientId,
  })
  return { stats: data?.contentStats ?? null, loading, error }
}
